import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GButton from "components/ui/button/Button";
// import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { subGroupList } from "../services/subGroupsService";
import AddSubGroupModal from "./modals/AddSubGroupModal";
import SubGroupTable from "../components/SubGroupTable";
import { useParams } from "react-router-dom";
import CryptoJS from 'crypto-js';
import NotAuthorizedCompo from "components/ui/NotAuthorizedCompo/NotAuthorizedCompo";
import { checkIdExists } from "utils/cheackAuth";
import useDecryptedPrivilege from "hooks/useDecryptedPrivilege ";

const SubGroups = () => {

  const retrievedArray =useDecryptedPrivilege()
  const ManageMenu = checkIdExists(retrievedArray, 38);
  const ReadMenu = checkIdExists(retrievedArray, 37);

  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });


  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useParams();
  
  const subGroup = useSelector((state) => state.subGroups);

  const [showSubGroups, setShowSubGroups] = useState(false);

  useEffect(() => {
    dispatch(subGroupList(id.groupId));
  }, [dispatch,id]);

  if(showSubGroups && ManageMenu===false){
    toast2({ description:  t("general.authorization")})
    setShowSubGroups(false)
  }
  
  return (
    <Box>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        mb={6}
      >
        <Text color="text" textTransform="capitalize">
          {t("pages.groups.subgroups")}
        </Text>

        <GButton
          title={t("pages.groups.add_subgroups")}
          bg="light"
          color="text"
          fontSize="14px"
          border="1px solid"
          borderColor="border"
          hover={{ bg: "light" }}
          onClick={() => setShowSubGroups(true)}
        />
      </Flex>

      {subGroup.isLoading ? (
        <Spinner />
      ) : subGroup.subGroupsData?.length === 0 ? (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      ) : subGroup.subGroupsData?.length > 0 ? (
        <SubGroupTable
        subGroupList={subGroup.subGroupsData}
        />
      ) : (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      )}

      {showSubGroups && (
        <AddSubGroupModal onClose={() => setShowSubGroups(false)} />
      )}


    </Box>
  );
};

export default SubGroups;
